<template>
  <footer class="bg-[#1a1a1a] border-t border-white/10 text-gray-400 text-sm py-6">
    <div class="max-w-7xl mx-auto px-4 flex flex-col items-center gap-4 text-center">

      <!-- Email -->
      <a
        href="mailto:contato@getlance.com.br"
        class="inline-flex items-center gap-2 hover:text-[#b99a52] transition"
        aria-label="Enviar e-mail"
      >
        <svg viewBox="0 0 24 24" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 6h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z"/>
          <path d="m22 8-10 7L2 8"/>
        </svg>
        contato@getlance.com.br
      </a>

      <!-- Desenvolvido por -->
      <div class="flex items-center gap-2">
        <span>Desenvolvido por</span>

        <a
          href="https://www.guitecnology.com.br"
          target="_blank"
          rel="noopener noreferrer"
          class="text-white font-medium hover:text-[#b99a52] transition"
        >
          Guitecnology
        </a>
      </div>

      <!-- Copyright -->
      <div>
        © {{ new Date().getFullYear() }} GetLance - Todos os direitos reservados.
      </div>

    </div>
  </footer>
</template>

<script setup></script>

<style scoped></style>